export default {
  headerContent: {
    title: 'Atlas Sigorta Kasko Sigortası Teklifi Hesaplama',
    slogan: "Araç Kasko Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'ARAÇ KASKO SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Atlas Mutuel Sigorta Araç Kasko Sigortası',
    description: {
      title: 'Atlas Sigorta Araç Kasko Sigortası Nedir? ',
      content: [
        'Kasko sigortası, taşıtın çarpma, çarpılma, çalınma gibi birçok riske karşı güvence sağlayan sigorta ürünüdür. Kasko sigortası trafik sigortasının aksine isteğe bağlı bir sigorta ürünüdür.',
        'İhtiyaç duyduğunuz sigorta miktarı kişisel ihtiyaçlarınıza göre belirlenir.',
        'Düzenli olarak araba sigortası fiyatları için alışveriş yapmak, sizin için en iyi poliçeyi ve en ucuz otomobil sigortasını bulmanın tek yoludur. Temiz bir siciliniz olsa ve sigorta şirketinizden memnun olsanız bile, başka bir yerde daha iyi bir anlaşma bulabilirsiniz.'
      ]
    },
    subContent: {
      title: 'Atlas Sigorta Araç Kasko Sigortası Teminatları Nelerdir?',
      content: [
        {
          paragraph:
            'Atlas Sigorta kasko sigortası teminatları tercihlerinize göre değişmektedir.',
          subList: [
            'Aksesuar teminatı',
            'Anahtar kaybı',
            'Aracın yetkisiz kişilerce çekilmesi',
            'Asıl anahtar ile aracın çalınması',
            'Çarpma, çarpışma, devrilme, düşme, yuvarlanma, yanma, hırsızlık',
            'Deprem ve yanardağ püskürtmesi',
            'Ferdi kaza',
            'Grev, lokavt, kargaşalık, halk hareketleri ve terör',
            'Hasarsızlık koruma',
            'Hukuksal koruma',
            'İhtiyari mali sorumluluk',
            'İkame araç hizmeti',
            'Kemirgen ve diğer hayvanların vereceği zararlar',
            'Kıymet kazanma',
            'Kişisel eşya teminatı',
            'Kullanım ve gelir kaybı teminatı',
            'Manevi tazminat',
            'Mini onarım hizmeti',
            'Patlayıcı ve parlayıcı maddeler taşınması',
            'Sel ve su baskını',
            'Sigara ve benzeri maddelerin temasıyla meydana gelen zararlar',
            'Taşınan emtea teminatı',
            'Tedavi masrafları',
            'Toprak kayması, fırtına, dolu, yıldırım',
            'Yanlış akaryakıt dolumu teminatı',
            'Yeni değer teminatı',
            'Yol yardım hizmeti',
            'Yurt dışı teminatıdır.'
          ]
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Araç Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Araç Kasko Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Araç Kasko Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Araç Kasko Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Araç Kasko Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle:
    'Atlas Mutuel Sigorta Araç Kasko Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: [
    {
      title: 'Atlas Sigorta Kasko Sigortası Teminat Dışı Haller Nelerdir?',
      content: [
        {
          paragraph: null,
          subList: [
            'Araç anahtarının üzerinde unutulması sonucunda aracın çalınması,',
            'Otopark veya vale fişi almaksızın teslim edilen aracın çalınması ve çalınmaya teşebbüs edilmesinden kaynaklı hasarlar,',
            'Vücuda uyuşukluk veren maddeler kullanım sonrasında oluşan hasarlar,',
            'Sigortalının kasten vereceği hasarlar,',
            'Poliçe teminatlarına eklenmemesi durumunda deprem, sel veya su baskınları sonucu oluşan hasarlar.'
          ]
        }
      ]
    },
    {
      title: 'Atlas Sigorta Kasko Sigortası İçin Gerekli Evraklar Nelerdir?',
      content: [
        {
          paragraph:
            'Atlas Sigorta’dan kasko sigortası alabilmek için gerekli evraklar mevcuttaki veya 2. El olarak yeni alınmış araçlar için sadece ruhsat yeterlidir. Sıfır araçlarda ise sigortalı TC veya vergi kimlik numarası, araç plaka il kodu ve proforma fatura yeterlidir.',
          subList: null
        }
      ]
    },
    {
      title: 'Atlas Sigorta Kasko Yaş Sınırı Nedir?',
      content: [
        {
          paragraph:
            'Atlas Sigorta kasko sigortası ürünü 10 yaş ve altı araçlar için geçerlidir.',
          subList: null
        }
      ]
    },
    {
      title: 'Atlas Sigorta Araç Kasko Sigortası Çeşitleri Nelerdir?',
      content: [
        {
          paragraph:
            'Atlas Sigorta kasko sigortası adı altında 3 adet kasko ürünü sunmaktadır.',
          subList: null
        },
        {
          paragraph: '<strong>Bu ürünler;</strong>',
          subList: [
            'Bireysel kasko sigortası,',
            'Ticari kasko sigortası,',
            'Rent a car kasko sigortasıdır.'
          ]
        }
      ]
    },
    {
      title: 'Atlas Sigorta Bireysel Kasko Nedir?',
      content: [
        {
          paragraph:
            'Atlas Sigorta’nın şahıslar için sadece kamyonet ve otomobil kullanım tarları için düzenlediği sigorta ürünüdür.',
          subList: null
        }
      ]
    },
    {
      title: 'Atlas Sigorta Bireysel Kasko Teminatları Nelerdir?',
      content: [
        {
          paragraph:
            'Bireysel kasko sigortası ile birçok riski teminat altına alabilirsiniz.',
          subList: [
            'Çarpma, çarpışma, devrilme, düşme, yuvarlanma, yanma, hırsızlık',
            'Grev, lokavt, kargaşalık, halk hareketleri ve terör',
            'Deprem ve Yanardağ Püskürtmesi',
            'Toprak Kayması, Fırtına, Dolu, Yıldırım',
            'Sel ve Su Baskını',
            'Asıl anahtar ile aracın çalınması',
            'Anahtar kaybı',
            'Aracın yetkisiz kişilerce çekilmesi',
            'Sigara ve benzeri maddelerin temasıyla meydana gelen zararlar',
            'Kemirgen ve diğer hayvanların vereceği zararlar',
            'Kıymet kazanma',
            'Yeni değer teminatı',
            'Yurt dışı teminatı',
            'Yanlış akaryakıt dolumu teminatı',
            'Kullanım ve gelir kaybı teminatı',
            'Kişisel eşya teminatı',
            'Aksesuar teminatı',
            'Patlayıcı ve parlayıcı maddeler taşınması',
            'Taşınan emtea teminatı',
            'Hasarsızlık Koruma',
            'İhtiyari Mali Sorumluluk',
            'Manevi tazminat',
            'Ferdi Kaza',
            'Tedavi Masrafları',
            'Hukuksal Koruma',
            'Mini Onarım Hizmeti',
            'Yol Yardım Hizmeti',
            'İkame Araç Hizmetidir.'
          ]
        }
      ]
    },
    {
      title: 'Atlas Sigorta Ticari Kasko Nedir?',
      content: [
        {
          paragraph:
            'Ticari kasko sigortası, tüzel kişiliklerin araçlarını hırsızlık, çarpma ve çarpılma riskleri ve birçok riske karşı güvence altına almaktadır. ',
          subList: null
        }
      ]
    },
    {
      title: 'Atlas Sigorta Ticari Kasko Teminatları Nelerdir?',
      content: [
        {
          paragraph: null,
          subList: [
            'Aksesuar teminatı',
            'Anahtar kaybı',
            'Aracın yetkisiz kişilerce çekilmesi',
            'Asıl anahtar ile aracın çalınması',
            'Çarpma, çarpışma, devrilme, düşme, yuvarlanma, yanma, hırsızlık',
            'Deprem ve yanardağ püskürtmesi',
            'Ferdi kaza',
            'Grev, lokavt, kargaşalık, halk hareketleri ve terör',
            'Hasarsızlık koruma',
            'Hukuksal koruma',
            'İhtiyari mali sorumluluk',
            'İkame araç hizmeti',
            'Kemirgen ve diğer hayvanların vereceği zararlar',
            'Kıymet kazanma',
            'Kişisel eşya teminatı',
            'Kullanım ve gelir kaybı teminatı',
            'Manevi tazminat',
            'Mini onarım hizmeti',
            'Patlayıcı ve parlayıcı maddeler taşınması',
            'Sel ve su baskını',
            'Sigara ve benzeri maddelerin temasıyla meydana gelen zararlar',
            'Taşınan emtea teminatı',
            'Tedavi masrafları',
            'Toprak kayması, fırtına, dolu, yıldırım',
            'Yanlış akaryakıt dolumu teminatı',
            'Yeni değer teminatı',
            'Yol yardım hizmeti',
            'Yurt dışı teminatıdır.'
          ]
        }
      ]
    },
    {
      title: 'Atlas Sigorta Rent a Car Kasko Nedir?',
      content: [
        {
          paragraph:
            'Otomobil, kamyonet ve minibüs kullanım tarzı araçların kiralama sırasında (kiralanma zamanı içerinde) karşılaşabileceği hasarlar sonucu oluşacak maddi zararları poliçe kapsamı dahilinde güvence altına almaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Atlas Sigorta Rent a Car Kasko Teminatları Nelerdir?',
      content: [
        {
          paragraph: null,
          subList: [
            'Çarpma, çarpışma, devrilme, düşme, yuvarlanma, yanma, hırsızlık',
            'Grev, lokavt, kargaşalık, halk hareketleri ve terör',
            'Deprem ve yanardağ püskürtmesi',
            'Toprak kayması, fırtına, dolu, yıldırım',
            'Sel ve su baskını',
            'Asıl anahtar ile aracın çalınması',
            'Anahtar kaybı',
            'Aracın yetkisiz kişilerce çekilmesi',
            'Sigara ve benzeri maddelerin temasıyla meydana gelen zararlar',
            'Kemirgen ve diğer hayvanların vereceği zararlar',
            'Kıymet kazanma',
            'Yeni değer teminatı',
            'Yurt dışı teminatı',
            'Yanlış akaryakıt dolumu teminatı',
            'Kullanım ve gelir kaybı teminatı',
            'Kişisel eşya teminatı',
            'Aksesuar teminatı',
            'Patlayıcı ve parlayıcı maddeler taşınması',
            'Taşınan emtea teminatı',
            'Hasarsızlık koruma',
            'İhtiyari mali sorumluluk',
            'Manevi tazminat',
            'Ferdi kaza',
            'Tedavi masrafları',
            'Hukuksal koruma',
            'Mini onarım hizmeti',
            'Yol yardım hizmeti',
            'İkame araç hizmetidir.'
          ]
        }
      ]
    },
    {
      title: 'Atlas Sigorta Kasko Bozulursa Ne Kadar Artar?',
      content: [
        {
          paragraph:
            'Kasko hasarların sonucunda hasarsızlık basamağı düşmektedir. Bu düşüş yapmış olduğunuz hasar adedine göre düşmektedir. Örneğin 4. Basamak hasarsızlığı bulanan sigortalının poliçe vadesi içerinde 2 adet kazaya karışması sonucunda hasarsızlık basamağı 2. Kademeye düşmektedir.',
          subList: null
        }
      ]
    },
    {
      title: 'Atlas Sigorta Araç Kasko Meslek İndirimi Nedir?',
      content: [
        {
          paragraph:
            'Kasko sigortasında bulunan meslek indirimleri belirli meslek gruplarına özel indirim avantajı sağlamaktadır. Bu meslekler polis, öğretmen, doktor ve hemşire gibi meslek gruplarını kapsar.',
          subList: null
        }
      ]
    },
    {
      title: 'Atlas Sigorta Kasko Mini Onarım Teminatı Nedir?',
      content: [
        {
          paragraph:
            'Mini onarım teminatı aracınızda oluşacak küçük çaplı hasarları poliçenizdeki hasarsızlığınızı bozmadan yaptırmanızı olanak sağlamaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Atlas Sigorta Kasko Mini Onarım Neleri Kapsar?',
      content: [
        {
          paragraph: null,
          subList: [
            '5 cm çapa kadar boyasız göçük düzeltme,',
            '10 cm çapa kadar boyasız kaporta düzeltme,',
            '20 cm çapa kadar boya ve mini yapa tamiratı,',
            '5 cm çapa kadar iç döşeme leke çıkartma,',
            'Plastik tampon tamiridir.'
          ]
        }
      ]
    },
    {
      title: 'Atlas Sigorta Araç Kasko Anlaşmalı Servisler Nedir?',
      content: [
        {
          paragraph:
            'Kasko sigortası teminatları arasında sunulan anlaşmalı servis seçeneği araçta oluşacak hasar sonucunda sadece Atlas Sigorta ile anlaşmalı servisi kullanabileceğiniz ifade etmektedir. Anlaşmasız servis kullanımlarında hasar bedeli üzerinden muafiyet uygulanabilir.',
          subList: null
        }
      ]
    },
    {
      title: 'Kasko Hasarlarında Atlas Sigorta’nın İstediği Evraklar Nelerdir?',
      content: [
        {
          paragraph:
            'Hasar anında istenen belgeler hasar ve hasar büyüklüğüne göre farklılık gösterebilir.',
          subList: [
            'Kaza Tespit Tutanağı,',
            'Ruhsat fotokopisi,',
            'Ehliyet fotokopisi,',
            'Alkol raporu,',
            'Araç ve olay yeri resimleri.'
          ]
        }
      ]
    },
    {
      title:
        'Atlas Sigorta Aracı Başkası Kullanırsa Kasko Sigortasını Hasarı Karşılar Mı?',
      content: [
        {
          paragraph:
            'Almış olduğunuz kasko sigortasında sürücü kısıtlamaması bulunmaması durumunda karşılamaktadır.',
          subList: null
        }
      ]
    },
    {
      title:
        'Atlas Sigorta Tek Taraflı Kazalarda Kasko Sigortası Hasarı Karşılar Mı?',
      content: [
        {
          paragraph:
            'Tek taraflı kazaların kasten yapılmaması durumunda kasko poliçeniz karşılamaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Atlas Sigorta Kasko Far Hasarlarını Karşılar Mı?',
      content: [
        {
          paragraph:
            'Far hasarları kasten olmaması kaydıyla poliçeniz kapsamında karşılanmaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Atlas Sigorta Araç Kasko Muhasebe Kaydı Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Muhasebe kaydı için poliçenizin bir nüshasını muhasebenize iletmeniz yeterli olacaktır.',
          subList: null
        }
      ]
    },
    {
      title: 'Atlas Sigorta Kasko Fiyatını Nasıl Öğrenebilirim?',
      content: [
        {
          paragraph:
            'Kasko sigortası fiyatları araç bilgileri, sigortalı geçmiş kullanım ve sigortalının seçeceği teminatlar göre değişmekte olup kişiye özel olarak hesaplanmaktadır.',
          subList: null
        },
        {
          paragraph:
            'Size özel teklif hazırlanması için başvuru formunu doldurmanız yeterli olacaktır.',
          subList: null
        }
      ]
    },
    {
      title: 'Atlas Sigorta Araç Kasko Sigortası Sorgulama Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Var olan sigortanızın bitiş tarihini teminatlarını e devlet üzerinden görebileceğiniz gibi Atlas Sigorta ile iletişime geçerek de öğrenebilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title:
        'Atlas Sigorta’dan Satın Alınmayı Düşünülen Araca Kasko Teklifi Alınır Mı?',
      content: [
        {
          paragraph:
            'Doğru kasko teklifi alabilmek için aracın satın alınmış olması gerekir. Satın alma öncesinde alınan teklifler doğru teklif olarak değerlendirilmemektedir.',
          subList: null
        }
      ]
    },
    {
      title: 'Atlas Sigorta Tahmini Kasko Fiyatları Neye Göre Hesaplanır?',
      content: [
        {
          paragraph:
            'Kasko fiyatları araç bedeli, araçta bulunan harici aksesuar bedeli, sigortalı hasar geçmişi ve sigortalının ihtiyaçları doğrultusunda seçeceği teminatlara göre hesaplanmaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Atlas Sigorta Ortalama Araç Kasko Sigortası Fiyatları Ne Kadar?',
      content: [
        {
          paragraph: 'Kasko fiyatları istediğiniz teminatlar ve geçmiş kullanımlara göre değişmektedir. ',
          subList: null
        },
        {
          paragraph: 'Kasko sigortası teklifi almak için alokasko.com üzerinden başvuru formu doldurabilir veya 0216 371 67 77 numaralı hattan uzman danışmanlarımızla iletişime geçebilirsiniz.',
          subList: null
        }
      ]
    }
  ]
}
